<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import simplebar from "simplebar-vue";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      simplebar,
  },
  data() {
    return {
      errorMessage: "",
      title: "History",
      items: [
        {
          text: "History",
          href: "/",
        },
        {
          text: "list",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
        ticketId:"",
      checked: true,
        file:null,
      errors: null,
        history:[],
        visible:false,
        message:"",
      form: {
        message: "",
        message_file: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        message: {
        required,
      },
    },
  },
    created() {
        this.ticketId = this.$route.params.id;
    },
    mounted() {
        this.getRoleDetail();
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      onFileChange(e) {
          // console.log(e);
          this.form.message_filename =
              "Selected File: " + e.target.files[0].name;
          this.form.message_file = e.target.files[0];
      },
      getFile(file){
          this.file=file;
      },

      onClick() {
          window.open(this.file);
          // axios({
          //     url: this.file,
          //     method: 'GET',
          //     responseType: 'blob',
          //     headers: {
          //         'Access-Control-Allow-Origin': '*'
          //     }
          // }).then((response) => {
          //     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          //     var fileLink = document.createElement('a');
          //     var value=this.file;
          //     var lastSix=value.substr(value.length-5);
          //     fileLink.href = fileURL;
          //     fileLink.setAttribute('download', lastSix);
          //     document.body.appendChild(fileLink);
          //
          //     fileLink.click();
          // });

      },
      async getRoleDetail() {
          try {
              axios
                  .post("/api/support-ticket/history/" + this.ticketId, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.history= response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
        this.submitted = true;
        this.$v.$touch();
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')
                    .content,
            },
        };
        event.preventDefault();
        var formData = this.gatherFormData();
        axios
            .post("/api/support-ticket/history/create", formData, config)
            .then((response) => {
                if (response.data.status) {
                    this.$refs.messageForm.reset();
                    this.getRoleDetail();
                    this.$router.go(0);
                } else {
                    var str = response.data.message.message;
                    var jsonParse = JSON.parse(str);
                    this.errorCheck(jsonParse);
                }
            })
            .catch((error) => {
                if (error.response != undefined) {
                    this.errors = error.response.data.errors;
                }
            });
    },
      gatherFormData() {
          const data = new FormData();
          data.append("accessToken", localStorage.getItem("access_tocken"));
          data.append("message_file", this.form.message_file);
          data.append("message", this.form.message);
          data.append("ticket_id",this.ticketId);
          return data;
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      // console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>

              <b-modal
                  id="modal-center1"
                  centered
                  hide-footer
              >
                  <div class="text-center padding-bottom-20px">
                      <button class="btn btn-primary" @click="onClick()">Download</button>
                  </div>
                  <div>
                      <img class = "img-responsive" width = "100%" :src="file" alt="no preview for file">
                  </div>



              </b-modal>
              <div>
                  <div class="chat-conversation p-3">
                      <simplebar
                          style="max-height: 470px"
                          id="containerElement"
                          ref="current"
                      >
                          <ul class="list-unstyled" v-for="(message,index) in history" v-bind:key="index">
<!--                              <li>-->
<!--                                  <div class="chat-day-title">-->
<!--                                      <span class="title">Today</span>-->
<!--                                  </div>-->
<!--                              </li>-->
                              <li>
                                  <div class="conversation-list">
                                      <div class="ctext-wrap">
                                          <div class="conversation-name">{{message.created_by.first_name}} {{message.created_by.last_name}}</div>
                                          <p>{{message.message}}</p>
                                          <b-button v-if="message.file!=null" v-b-modal.modal-center1 variant="primary" @click.prevent="getFile(message.file)">File</b-button>
                                      </div>
                                  </div>
                              </li>

                          </ul>
                      </simplebar>
                  </div>
                  <div class="p-3 chat-input-section">
                      <b-form class="needs-validation" ref="messageForm" @submit.prevent="formSubmit">
                          <div class="row">
                              <div class="col-md-8">
                                  <div class="form-group">
                                      <label>File</label>
                                      <div class="custom-file">
                                          <input id="file" type="file" name="message_file" v-on:change="onFileChange($event)" class="custom-file-input" />
                                          <label class="custom-file-label" for="file">File</label>
                                      </div>
                                  </div>
                              </div>
                              <div class="col-md-8">
                                  <div class="form-group">
                                      <label class="required" for="message">Message</label>
                                      <input
                                          id="message"
                                          v-model="form.message"
                                          name="spt_message"
                                          type="text"
                                          class="form-control"
                                          placeholder="Write Message"
                                          value
                                          :class="{ 'is-invalid': submitted && $v.form.message.$error }"
                                      />
                                      <div
                                          v-if="submitted && $v.form.message.$error"
                                          class="invalid-feedback"
                                      >
                                          <span v-if="!$v.form.message.required">This value is required.</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <button class="btn btn-primary" type="submit">Send Message</button>
                      </b-form>
                  </div>
              </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.file-preview{
    width:350px;
    height:300px;
}
.down-button-position{
    position: absolute;
    right: 20px;
}
.padding-bottom-20px{
    padding-bottom: 15px;
}
#modal-center1 .modal-header{
    display:none!important;
}
</style>
